module.exports = __webpack_public_path__ + "037043f8dcdf01c5f7f39b256c37cd80.svg";